import { useTranslation } from 'react-i18next';

import { useTheme } from 'hooks';
import { ToggleBtn } from './theme-changer.v2.styled';

const SunIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden>
    <circle cx="12" cy="12" r="4.2" />
    <path d="M12 2.5v2.4M12 19.1v2.4M4.6 4.6l1.7 1.7M17.7 17.7l1.7 1.7M2.5 12h2.4M19.1 12h2.4M4.6 19.4l1.7-1.7M17.7 6.3l1.7-1.7" />
  </svg>
);

const MoonIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M20.5 14.2A8.3 8.3 0 0 1 9.8 3.5a8.5 8.5 0 1 0 10.7 10.7z" />
  </svg>
);

/**
 * Modern sun/moon theme toggle for the v2 redesign. Shows the icon of the mode
 * it will switch to. `onDark` styles it for a dark surface (asphalt header).
 */
export const ThemeChangerV2 = ({ onDark = false }) => {
  const { t } = useTranslation();
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';

  return (
    <ToggleBtn type="button" $onDark={onDark} onClick={toggle} title={isDark ? t('ui.themeLight') : t('ui.themeDark')} aria-label={t('ui.themeToggle')}>
      {isDark ? <SunIcon /> : <MoonIcon />}
    </ToggleBtn>
  );
};
